import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getArticles, deleteArticle } from "../../api/articlesApi";
import { translateAuthError } from "../../api/authApi";

// Section C (admin-only): lists every article with edit/delete actions and
// a link to create a new one. Reachable only through AdminRoute.
function AdminArticlesPage() {
  const [articles, setArticles] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    getArticles()
      .then(setArticles)
      .catch((err) => setError(translateAuthError(err.message)))
      .finally(() => setLoading(false));
  }, []);

  async function handleDelete(id) {
    if (!window.confirm("این مقاله حذف شود؟")) return;
    try {
      await deleteArticle(token, id);
      setArticles((prev) => prev.filter((a) => a.id !== id));
    } catch (err) {
      setError(translateAuthError(err.message));
    }
  }

  return (
    <div className="admin-page">
      <Link to="/" className="back-link">
        ← بازگشت به سایت
      </Link>

      <div className="admin-page-header">
        <h1>مدیریت مقاله‌ها</h1>
        <Link to="/admin/articles/new" className="nav-cta">
          مقالهٔ جدید
        </Link>
      </div>

      {error && <p className="error">{error}</p>}

      {!loading && articles.length === 0 && !error && (
        <p className="admin-empty">هنوز مقاله‌ای ثبت نشده است.</p>
      )}

      <ul className="admin-article-list">
        {articles.map((a) => (
          <li key={a.id} className="admin-article-row">
            <span>{a.title_fa || a.title_en}</span>
            <div className="admin-actions">
              <button type="button" onClick={() => navigate(`/admin/articles/${a.id}/edit`)}>
                ویرایش
              </button>
              <button type="button" onClick={() => handleDelete(a.id)}>
                حذف
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default AdminArticlesPage;
